import React from "react";

export default function EmptyPost({ dark }) {
  return (
    <div className={"container main-card-container mt-4 "}>
      <div className={"card text-xs-center " + (dark && " divbg-in-darkmode ")}>
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-start align-items-center">
            <p className={(dark && "text-white")}>No posts found.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
